/**
 * Created by andrey on 08.08.2025
 */

cc.MoveTo = function (duration, position, y) {
    cc.MoveBy.prototype.constructor.call(this);

    this._endPosition = cc.p(0, 0);

    if (position !== undefined) {
        this.initWithDuration(duration, position, y);
    }
};

cc.MoveTo.prototype = Object.assign(Object.create(cc.MoveBy.prototype), {
    constructor: cc.MoveTo,

    initWithDuration: function (duration, position, y) {
        if (cc.MoveBy.prototype.initWithDuration.call(this, duration, position, y)) {
            if (position.x !== undefined) {
                y = position.y;
                position = position.x;
            }

            this._endPosition.x = position;
            this._endPosition.y = y;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.MoveBy.prototype.startWithTarget.call(this, target);
        this._positionDelta.x = this._endPosition.x - target.getPositionX();
        this._positionDelta.y = this._endPosition.y - target.getPositionY();
    }
});

cc.moveTo = (duration, position, y) => new cc.MoveTo(duration, position, y);
